import $http from './http';
export function appealList(data, params) {
  return $http({
    url: `/xmt/appeal/list`,
    data,
    params,
    method: 'post'
  });
}

export function appealDetail(id) {
  return $http({
    url: `/xmt/appeal/get/${id}`,
    // data: data
  });
}
//申诉审核
export function appealSubmit(data) {
  return $http({
    url: `/xmt/appeal/submit`,
    data: data,
    method: 'post'
  });
}
//通过postId和人员id查询申诉信息
export function getAppealDetail(data) {
    return $http({
      url: `/xmt/appeal/getAppealDetail`,
      method: 'post',
      data: data
    });
}
